import { BehaviorSubject, debounceTime } from "rxjs";
import { create } from "zustand";

interface FilterState {
  openChoicesModal: boolean;
  searchValue:string;
  startDate: string;
  endDate: string;
  validFrom: string;
  validTo: string;

  // Actions
  setOpenChoicesModal: (val: boolean) => void;
  setSearchValue:(val:string)=>void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setValidFrom: (val: string) => void;
  setValidTo: (val: string) => void;
  resetFilter: () => void;

}

export const useSurveysFilterStore = create<FilterState>((set) => ({
  openChoicesModal: false,
  searchValue:"",
  startDate: "",
  endDate: "",
  validFrom: "",
  validTo: "",

  setOpenChoicesModal: (val) => set({ openChoicesModal: val }),
  setSearchValue:(val)=>set({searchValue:val}),
  setStartDate: (val) => set({ startDate: val }),
  setEndDate: (val) => set({ endDate: val }),
  setValidFrom: (val) => set({ validFrom: val }),
  setValidTo: (val) => set({ validTo: val }),
  resetFilter: () =>
    set({
      startDate: "",
      endDate: "",
      validFrom: "",
      validTo: "",
    }),
}));

export const useActiveFilterCount = () =>
  useSurveysFilterStore((state) => {
    const filters = [
      state.searchValue,
      state.startDate,
      state.endDate,
      state.validFrom,
      state.validTo,
    ];
    return filters.filter((val) => val && val.trim() !== "").length;
  });